import { Button, Embed, Grid, Label } from 'semantic-ui-react'
import React, { Component } from 'react'
import CloudinaryPicSet from '../components/CloudinaryPicSet'
import MobileDetect from 'mobile-detect'
import PropTypes from 'prop-types'
import Slider from '../components/Slider'
import _ from 'lodash'

const userAgent = navigator.userAgent
const md = new MobileDetect(userAgent)
const isMobile = Boolean(md.mobile())

function PortfolioItem(props) {
	let embed = false
	if (props.youtube) {
		// Mobile's don't seem to auto-play YouTube and can't swipe on the iframe, so default off
		if (props.autoloop && !isMobile) {
			embed = (
				<div className="ui 4:3 active embed">
					<div className="embed">
						<iframe
							title={props.header}
							width="100%"
							height="100%"
							src={`https://www.youtube.com/embed/${
								props.youtube
							}?rel=0&autoplay=1&loop=1&playlist=${
								props.youtube
							}&modestbranding=1&showinfo=0&controls=0`}
							frameBorder="0"
							allowFullScreen
						/>
					</div>
				</div>
			)
		} else {
			embed = (
				<Embed
					aspectRatio="4:3"
					brandedUI={false}
					id={props.youtube}
					placeholder={`https://res.cloudinary.com/zinid/image/upload/q_65,w_960/anthony.astige.com/portfolio/${
						props.placeholder
					}.jpg`}
					source="youtube"
				/>
			)
		}
	}
	return (
		<Grid className="portfolio-item" columns="equal" stackable>
			<Grid.Column className="media">
				{props.image ? (
					<CloudinaryPicSet
						className="ui image"
						alt={props.header}
						filename={`anthony.astige.com/portfolio/${props.image}`}
						defaultWidth={600}
						widths={[960, 768, 600, 400, 300]}
						ext="jpg"
					/>
				) : (
					''
				)}
				{embed}
			</Grid.Column>
			<Grid.Column className="content" verticalAlign="middle" textAlign="center">
				<h3>{props.header}</h3>
				<p>{props.description}</p>
				<p>
					<Button primary as="a" href={props.visitUrl} target="anthony-portfolio-item">
						Visit site
					</Button>
				</p>
				<div>
					{props.techs.sort().map(tech => (
						<Label size="tiny" key={tech}>
							{tech}
						</Label>
					))}
				</div>
			</Grid.Column>
		</Grid>
	)
}
PortfolioItem.propTypes = {
	visitUrl: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	header: PropTypes.string.isRequired,
	image: PropTypes.string,
	youtube: PropTypes.string,
	autoloop: PropTypes.bool,
	placeholder: PropTypes.string,
	techs: PropTypes.arrayOf(PropTypes.string).isRequired
}
export default class PortfolioSection extends Component {
	render() {
		let slides = [
			/*
			{
				url: '',
				title: '',
				header: '',
				description: '',
				visitUrl: '',
				techs: ['', '']
			},
			*/
			{
				url: 'inlinedWoffs',
				image: 'inlinedWoffs',
				title: 'Inlined Woffs',
				header: 'Inlined Woffs',
				description:
					'Tech tool to find & create tiny .woff fonts for instantly loading styled pages',
				visitUrl: 'https://inlined-woffs.zinid.com',
				techs: ['Express', 'Fonts', 'jQuery', 'JavaScript', 'CSS']
			},
			{
				url: 'beats',
				youtube: 'DMgMycyIK1M',
				autoloop: true,
				placeholder: 'beats',
				title: 'Beats',
				header: 'Beats by Anthony',
				description:
					'Tap your arrow keys on the beat to play, many levels, and a level editor',
				visitUrl: 'https://beats.zinid.com',
				techs: ['React', 'API: YouTube', 'HTML', 'CSS', 'Custom Algorithms', 'JavaScript']
			},
			{
				url: 'trelloCardAdder',
				title: 'Trello Card Adder',
				header: 'Trello Card Adder',
				description: 'Quickly jot text to Trello Cards',
				youtube: 'PNakrgWQ2Qs',
				placeholder: 'trelloCardAdder',
				visitUrl: 'https://glitch.com/edit/#!/trellocardadder',
				techs: ['API: Trello', 'JavaScript', 'Express']
			},
			{
				url: 'workoutTimer',
				image: 'workoutTimer',
				title: 'Workout Timer',
				header: 'Workout Timer',
				description:
					'Creates timers for different workouts allowing you to quickly change sets & timing',
				visitUrl: 'https://workout-timer.fowk.com',
				techs: ['Meteor', 'JavaScript', 'Bootstrap']
			},
			/*
			{
				url: 'vmsCFEC',
				image: 'vms',
				title: 'Virtual Machines',
				header: 'Virtual Machines',
				description:
					'Spins up temporary virtual machines on Digital Ocean for ad hoc volunteer teams',
				visitUrl: 'https://vms.codeforeauclaire.org',
				techs: ['API: Digital Ocean', 'Meteor', 'Bootstrap', 'JavaScript']
			},
			{
				url: 'wingr',
				image: 'wingr',
				title: 'Wingr',
				header: 'Wingr',
				description:
					'Functional proof of concept like Tinder where your friends find you dates',
				visitUrl: 'https://beta.wingr.net',
				techs: ['API: Facebook', 'Meteor', 'Bootstrap', 'JavaScript']
			},
			{
				url: 'shuttles',
				image: 'hotelAirportShuttle',
				title: 'Hotel Airport Shuttles',
				header: 'Hotel Airport Shuttles',
				description:
					'Gather and find hotels near airports with free shuttles, try SFO to see data',
				visitUrl: 'https://shuttles.fowk.com/',
				techs: ['API: Google Maps', 'Meteor', 'JavaScript']
			},
            */
			/*
			{
				url: 'reservations',
				image: 'reservations',
				title: 'Zinid LLC Reservations',
				header: 'Zinid LLC Reservations',
				description:
					'Reserve freelancer time (like mine) with pre-booking & bulk hour discounts',
				visitUrl: 'https://reservations.zinid.com/',
				techs: ['React', 'JavaScript', 'Semantic UI']
			},
            */
			{
				url: 'tmf',
				title: 'Track My Foods',
				image: 'trackMyFoods',
				header: 'Track My Foods',
				description:
					'Personal food tracking (calories, protein, ...) with personal recipes, meta nutrients, and more',
				visitUrl: 'https://www.trackmyfoods.com/',
				techs: ['Bootstrap', 'Blaze', 'Meteor', 'Custom Algorithms', 'JavaScript']
			},
			{
				url: 'trelloListFilter',
				title: 'Trello List Filter',
				youtube: 'x9UUnG9ksJw',
				placeholder: 'trelloListFilter',
				header: 'Trello List Filter',
				description: 'Chrome extension to filter Trello lists',
				visitUrl:
					'https://chrome.google.com/webstore/detail/trello-list-filter/nejmlobcaghdppkjgihmmeigobhgecnn',
				techs: ['API: Google Chrome', 'JavaScript']
			}
		]
		slides = _.sortBy(slides, 'title')
		return (
			<Slider
				slides={slides.map(el => ({
					url: el.url,
					title: el.title,
					element: <PortfolioItem key={el.title} {...el} />
				}))}
				title="Portfolio"
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/sections/PortfolioSection.js